import request from '../utils'

const MaintenanceApi = { 
    list: async (projectId, query) => {
        const req = request.get(`/api/project/${projectId}/maintenanceplan${query || ''}`)
        const res = await req;
        return res.body;
    },
    count: async (projectId,) => {
        const req = request.get(`/api/project/${projectId}/maintenanceplan/count`)
        const res = await req;
        return res.body;
    },
    create: async (projectId, maintenancePlan) => {
        const req = request.post(`/api/project/${projectId}/maintenanceplan`).send(maintenancePlan);
        const res = await req;
        return res.body;
    },
    update: async (projectId, maintenancePlan) => {
        const req = request.put(`/api/project/${projectId}/maintenanceplan`).send(maintenancePlan);
        const res = await req;
        return res.body;
    },
    delete: async (projectId, guid) => {
        const req = request.delete(`/api/project/${projectId}/maintenanceplan/${guid}`);
        await req;
    }
};

export default MaintenanceApi